import { useCallback } from 'react';

import { projectPaths } from 'app/routes/paths/project';
// Not the barrel: that would pull the lazily loaded Audit page into this chunk.
import { auditBaseRoutePath } from 'features/project-audit/routes';
import { treeBaseRoutePaths } from 'features/tree-view';
import { useNavigateToParentPage } from 'hooks/useNavigateToParentPage';

import { ADVANCED_TREE_STORE } from '../../../nodeQuery/advancedTree/store/AdvancedTreeStore';
import { useIsNodeDetailsPanelOpenInGrid } from './useIsNodeDetailsPanelOpen';

/**
 * Returns a function that navigates to the parent page of the current node details panel.
 * TODO: the open state of the node details panel should be managed in the state with soft navigation.
 */
export const useCloseNodeDetailsPanel = () => {
  return useNavigateToParentPage(PARENT_PAGE_WITH_NODE_DETAILS_PANEL_PATHS);
};

const PARENT_PAGE_WITH_NODE_DETAILS_PANEL_PATHS = [
  // =========== In the Grid ===========
  `${projectPaths.BASE}/views/:viewId/h/:headerId/n/:nodeId`,
  `${projectPaths.BASE}/views/:viewId/h/:headerId/q/:queryId`,
  treeBaseRoutePaths[0],
  `${projectPaths.BASE}/data/:queryId`,
  // =========== In the search page ===========
  `${projectPaths.BASE}/search`,
  `${projectPaths.PROPOSAL}/search`,

  // =========== In the proposal page ===========
  `${projectPaths.PROPOSAL}/views/:viewId/h/:headerId/n/:nodeId`,
  `${projectPaths.PROPOSAL}/views/:viewId/h/:headerId/q/:queryId`,
  treeBaseRoutePaths[1],
  `${projectPaths.PROPOSAL}/data/:queryId`,

  // =========== In the audit page ===========
  auditBaseRoutePath
];

/** Returns a function that closes the detail panel and also remove all selected rows. */
export const useCloseNodeDetailsPanelInGrid = () => {
  const isDetailsPanelOpen = useIsNodeDetailsPanelOpenInGrid();
  const removeAllSelectedRows = ADVANCED_TREE_STORE((state) => state.removeAllSelectedRows);
  const closeNodeDetailsPanel = useCloseNodeDetailsPanel();

  return useCallback(() => {
    if (isDetailsPanelOpen) {
      closeNodeDetailsPanel(removeAllSelectedRows);
    }
  }, [closeNodeDetailsPanel, isDetailsPanelOpen, removeAllSelectedRows]);
};
